// Product calculation utilities for price parts
// Extracted from apps/web/src/components/product/utils.ts

// Note: This function has a simpler implementation than the one in antd-form-utils.ts
// but is used by calcEstimatedPriceByCost, so we keep it for compatibility
export function isNotValidNumber(value: number) {
  if (Number.isNaN(Number(value))) {
    return true;
  }
  if (!value && value !== 0) {
    return true;
  }
  return false;
}

export function calcEstimatedPriceByCost({
  cost,
  defaultGrossMargin,
}: {
  cost: number;
  defaultGrossMargin: number | null;
}) {
  if (isNotValidNumber(cost) || defaultGrossMargin === null) {
    return null;
  }
  return (Number(cost) / (1 - defaultGrossMargin / 100)).toFixed(2);
}
